$(document).ready(function() {
  $('#shopify-section-1584623592687, #shopify-section-1584689067486, #shopify-section-product-recommendations').addClass('products-section');
  $('#shopify-section-1584689067486, #shopify-section-product-recommendations').addClass('pro-slider');


setTimeout(function(){
 $('.pro-slider ul').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
}, 2000);
  
$('.thumbnails-wrapper ul').slick({
    dots: false,
    vertical: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1
  });
  
  $('.plus').click(function () {
    if ($(this).prev().val() < 99) {
      $(this).prev().val(+$(this).prev().val() + 1);
    }
  });
  $('.minus').click(function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    }
  });
});